import { useSearchParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useContent } from "@/context/ContentContext";
import { useT } from "@/lib/translations";
import { trackConversion } from "@/lib/analytics";
import { CheckCircle, XCircle, ArrowLeft } from "lucide-react";
import PublicNav from "@/components/PublicNav";

export default function DonationSuccessPage() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const donationId = searchParams.get("donation_id");
  const amount = searchParams.get("amount");
  const error = searchParams.get("error");
  const isSuccess = status === "success";
  const { t } = useContent();
  const L = useT();

  // Fire conversion event on success page view
  useEffect(() => {
    if (isSuccess) {
      trackConversion("donation_completed", {
        donation_id: donationId,
        value: amount ? parseFloat(amount) : undefined,
        currency: "TRY",
      });
    }
  }, [isSuccess, donationId, amount]);

  return (
    <div className="min-h-screen bg-background" data-testid="donation-success-page">
      <PublicNav />
      <div className="flex items-center justify-center px-4 py-16 sm:py-24">
        <div className="max-w-md w-full text-center space-y-6">
          {isSuccess ? (
            <>
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto">
                <CheckCircle className="w-10 h-10 text-green-600" />
              </div>
              <h1 className="font-heading text-3xl">{L(t("donation.thanks_title", "Teşekkürler!"))}</h1>
              <p className="text-muted-foreground text-lg leading-relaxed">
                {L(t("donation.thanks_message", "Bağışınız başarıyla alındı. Kimsesiz canlara uzanan eliniz için çok teşekkür ederiz."))}
              </p>
            </>
          ) : (
            <>
              <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto">
                <XCircle className="w-10 h-10 text-red-500" />
              </div>
              <h1 className="font-heading text-3xl">{L("Ödeme Başarısız")}</h1>
              <p className="text-muted-foreground text-lg leading-relaxed">
                {error ? decodeURIComponent(error) : L("Ödeme işlemi tamamlanamadı. Lütfen tekrar deneyin.")}
              </p>
            </>
          )}
          <div className="flex flex-col gap-3 pt-4">
            <Link to="/canlar">
              <Button size="lg" className="w-full btn-pill bg-primary text-primary-foreground">
                {L("Canları Keşfet")}
              </Button>
            </Link>
            <Link to="/">
              <Button size="lg" variant="outline" className="w-full btn-pill">
                <ArrowLeft className="w-4 h-4 mr-2" /> {L("Ana Sayfa")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
